import { render } from "./FormParent.vue?vue&type=template&id=58a17dbe"
import script from "./FormParent.vue?vue&type=script&lang=js"
export * from "./FormParent.vue?vue&type=script&lang=js"

import "./FormParent.vue?vue&type=style&index=0&id=58a17dbe&lang=css"
script.render = render

export default script